import React, { Component } from 'react';
import { Collapse, Navbar, NavbarToggler, NavItem, NavLink } from 'reactstrap';/*NavbarBrand,*/
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"
import { HashLink as Link } from 'react-router-hash-link';

import '../css/NavMenu.css';
import '../css/Social.css';
import '../css/Songlist.css';

//const MyModal = () => {
//    const [show, setShow] = useState(false);

//    const handleClose = () => setShow(false);
//    const handleShow = () => setShow(true);
//}

function scrollUp() {
    window.scrollBy(0, 50); // Move up by 20px
}

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }


    render() {

        return (
            <header className="nav-header">
                
                <Navbar className="navbar-expand-sm navbar-toggleable-sm navbar-dark ng-white border-bottom box-shadow mb-3" container light>
                   {/* <NavbarBrand tag={Link} to="/">DYS_REACT</NavbarBrand>*/}
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                    <Collapse className="d-sm-inline-flex " isOpen={!this.state.collapsed} navbar>{/*flex-sm-row-reverse*/}
                        <ul className="navbar-nav flex-grow">
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/" onClick={scrollUp}>Home</NavLink>
                            </NavItem>
                            {/*<NavItem>*/}
                            {/*    <NavLink tag={Link} className="text-dark" to="/Schedule" onClick={scrollUp}>Schedule</NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/Calendar" onClick={scrollUp}>Calendar</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/BioPage" onClick={scrollUp}>Bio</NavLink>
                            </NavItem>
                            {/*<NavItem>*/}
                            {/*    <NavLink tag={Link} className="text-dark" to="/Songlist">Songlists</NavLink>*/}
                            {/*</NavItem>*/}
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/Video" onClick={scrollUp}>Video</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/Contact" onClick={scrollUp}>Contact Us</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink tag={Link} className="text-dark" to="/BlogPage" onClick={scrollUp}>Captains Log</NavLink>
                            </NavItem>
                        </ul>
                    </Collapse>
                   
                </Navbar>

                <div className="top-social-wrapper">

                    <div className="top-social-headline">
                        Follow Dirty Yachtin 
                    </div>

                    <div className="top-social-subtext">
                        Upcoming shows, videos & behind-the-scenes
                    </div>

                    <div className="top-social">

                        <a href="https://www.facebook.com/DYSYachtRock" target="_blank" rel="noopener noreferrer" className="social-btn facebook" >
                            <FontAwesomeIcon icon={faFacebook} />
                            <span>Facebook</span>
                        </a>

                        <a href="https://instagram.com/dirtyyachtin" target="_blank" rel="noopener noreferrer" className="social-btn instagram">
                            <FontAwesomeIcon icon={faInstagram} />
                            <span>Instagram</span>
                        </a>

                    </div>

                </div>
            </header>


        );
    }
}
